/* eslint-disable react-hooks/exhaustive-deps */
import { Search, RotateCw, Copy } from 'lucide-react'
import { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Table
} from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import Select from 'react-select'
import Loader from '../../../components/atoms/Loader'
import { BadgeStatusPrLists } from '../../../components/atoms/StatusLabel'
import TableAction from '../../../components/atoms/Table/TableAction'
import TablePagination from '../../../components/atoms/Table/TablePagination'
import api from '../../../config/AxiosInstance'
import { convertDateWithTime } from '../../../helpers/constants'
import '../../../styles/style.css'
import * as Common from '../../../utils/Common'
import toast, { Toaster } from 'react-hot-toast'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

const SelectStyles = {
  control: (base, state) => ({
    ...base,
    height: 45,
    minHeight: 45,
    borderRadius: '10px',
    borderColor: state.isFocused ? 'var(--primary-orange)' : '#e9ecef',
    boxShadow: state.isFocused ? '0 0 0 4px rgba(248, 157, 29, 0.1)' : 'none',
    backgroundColor: '#ffffff',
    border: '1px solid #e9ecef',
    fontSize: '0.9rem'
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: '45px',
    padding: '0 12px'
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px'
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#495057'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? 'var(--primary-orange)'
      : state.isFocused
        ? '#fff5e6'
        : null,
    color: state.isSelected ? 'white' : '#333',
    cursor: 'pointer'
  })
}

const FormControlStyle = {
  height: '45px',
  borderRadius: '10px',
  border: '1px solid #e9ecef',
  backgroundColor: '#ffffff',
  fontSize: '0.9rem'
}

const STATUSES = [
  { value: 'unassigned', label: 'Unassigned' },
  { value: 'waiting', label: 'Waiting' },
  { value: 'done', label: 'Done' }
]

function RequestReturn() {
  const navigate = useNavigate()
  const [data, setData] = useState([])
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text)
    toast.success('Copied to clipboard')
  }
  const [customers, setCustomers] = useState([])
  const [warehouses, setWarehouses] = useState([])
  const [meta, setMeta] = useState({
    per_page: 10,
    current_page: 1,
    total_row: 0,
    total_page: 0
  })
  const [filter, setFilter] = useState({
    customer: '',
    q: '',
    warehouse_id: '',
    status: ''
  })
  const [debouncedQ, setDebouncedQ] = useState(filter.q)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQ(filter.q)
      setMeta((prev) => ({ ...prev, current_page: 1 }))
    }, 1000)

    return () => {
      clearTimeout(handler)
    }
  }, [filter.q])

  useEffect(() => {
    getData()
    if (!customers.length) {
      fetchUsers()
    }
    if (!warehouses.length) {
      fetchWarehouses()
    }
  }, [
    meta?.current_page,
    meta?.per_page,
    filter.customer,
    debouncedQ,
    filter.warehouse_id,
    filter.status
  ])

  const getData = async () => {
    try {
      setLoading(true)
      const params = {
        page: meta?.current_page || 1,
        per_page: meta?.per_page || 10,
        customer: filter?.customer || '',
        q: debouncedQ,
        warehouse_id: filter.warehouse_id,
        status: filter.status
      }
      const res = await api.get('outbound/request-return', { params })
      const { data: dataResponse, metadata: metaResponse } = res.data
      setData(dataResponse)
      setMeta((prev) => ({
        ...prev,
        total_row: metaResponse.total_row,
        total_page: metaResponse.total_page
      }))
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoading(false)
    }
  }

  const fetchUsers = async () => {
    try {
      const res = await api.get('outbound/request-return/customers')
      const { data: dataResponse } = res.data
      setCustomers(dataResponse)
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  const fetchWarehouses = async () => {
    try {
      const params = {
        type: 'internal'
      }
      const response = await api.get('/master/warehouses/all', { params })
      const { data } = response.data
      setWarehouses(data)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  function handleOnChangeMeta(e) {
    const perPageValue = parseInt(e.target.value, 10)
    setMeta((prevMeta) => ({
      ...prevMeta,
      per_page: perPageValue,
      current_page: 1
    }))
  }

  const handlePageChange = (data) => {
    setMeta((prevMeta) => ({
      ...prevMeta,
      current_page: parseInt(data.selected + 1)
    }))
    window.scrollTo(0, 0)
  }

  const handleReset = () => {
    setFilter({
      customer: '',
      q: '',
      warehouse_id: '',
      status: ''
    })
    setDebouncedQ('')
    setMeta((prev) => ({ ...prev, current_page: 1 }))
  }

  const warehouseOptions = [
    { value: '', label: 'All Warehouses' },
    ...warehouses.map((w) => ({ value: w.id, label: w.warehouse_name }))
  ]

  return (
    <>
      <Container fluid className="px-4">
        <Row className="mb-4 align-items-center">
          <Col>
            <div className="d-flex justify-content-between align-items-center">
              <h3 style={headerTitleStyle}>Request Return</h3>
              <Button
                variant="light"
                className="text-secondary fw-bold rounded px-3 border"
                onClick={handleReset}
                style={{ fontSize: '0.85rem' }}
              >
                <RotateCw size={16} className="me-2" />
                Reset Filters
              </Button>
            </div>
          </Col>
        </Row>

        <Card style={cardFilterStyle}>
          <Row className="g-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>Search</Form.Label>
                <InputGroup>
                  <InputGroup.Text
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #e9ecef',
                      borderRight: 'none',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px'
                    }}
                  >
                    <Search size={14} className="text-muted" />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="RR, DC, Outbound Code"
                    value={filter.q}
                    onChange={(e) =>
                      setFilter({ ...filter, q: e.target.value })
                    }
                    style={{
                      ...FormControlStyle,
                      borderLeft: 'none',
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0
                    }}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>Warehouse</Form.Label>
                <Select
                  name="warehouse_id"
                  id="warehouse_id"
                  value={warehouseOptions.find(
                    (o) => o.value === filter.warehouse_id
                  )}
                  onChange={(e) =>
                    setFilter({ ...filter, warehouse_id: e?.value || '' })
                  }
                  options={warehouseOptions}
                  styles={SelectStyles}
                  placeholder="All Warehouses"
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>Status</Form.Label>
                <Select
                  isClearable
                  name="status"
                  id="status"
                  value={
                    filter.status
                      ? STATUSES.find((s) => s.value === filter.status)
                      : null
                  }
                  onChange={(e) =>
                    setFilter({ ...filter, status: e?.value || '' })
                  }
                  options={STATUSES}
                  styles={SelectStyles}
                  placeholder="All Statuses"
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>CUSTOMER</Form.Label>
                <Select
                  isClearable
                  id="customer"
                  styles={SelectStyles}
                  onChange={(e) => {
                    setFilter({ ...filter, customer: e ? e.value : '' })
                    setMeta((prev) => ({ ...prev, current_page: 1 }))
                  }}
                  options={customers.map((customer) => ({
                    value: customer.customer,
                    label: customer.customer
                  }))}
                  placeholder="Select Customer"
                  value={
                    filter.customer
                      ? {
                          value: filter.customer,
                          label: filter.customer
                        }
                      : null
                  }
                />
              </Form.Group>
            </Col>
          </Row>
        </Card>

        <Row className="mt-4">
          <Col md={12}>
            <Table
              hover
              size="sm"
              responsive
              className="shadow-sm mb-5 bg-white"
              style={{
                borderRadius: '12px',
                overflow: 'hidden',
                fontSize: '0.9rem'
              }}
            >
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    #RR
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    #DC
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Customer
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Source Warehouse
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    #Outbound
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Status
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Date
                  </th>
                  <th
                    className="p-2 align-middle text-end"
                    style={tableHeaderStyle}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody style={{ fontSize: '13px' }}>
                {loading && (
                  <tr>
                    <td className="p-5 text-center" colSpan={8}>
                      <Loader />
                    </td>
                  </tr>
                )}
                {!loading && data.length === 0 && (
                  <tr>
                    <td
                      className="p-5 text-center fw-bold text-muted"
                      colSpan={8}
                    >
                      No data
                    </td>
                  </tr>
                )}
                {!loading &&
                  data.length > 0 &&
                  data.map((item, index) => (
                    <tr
                      key={`${item.id}-${index}`}
                      style={{ borderBottom: '1px solid #f0f0f0' }}
                    >
                      <td className="p-2 align-middle fw-semibold text-primary">
                        <div className="d-flex align-items-center gap-2">
                          {item.code}
                          <Copy
                            size={14}
                            className="text-muted cursor-pointer"
                            style={{
                              cursor: 'pointer',
                              opacity: 0.5,
                              transition: 'opacity 0.2s'
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.opacity = 1)
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.opacity = 0.5)
                            }
                            onClick={() => handleCopy(item.code)}
                            title="Copy RR Number"
                          />
                        </div>
                      </td>
                      <td className="p-2 align-middle">
                        <div className="d-flex align-items-center gap-2">
                          {item.dc_no || '-'}
                          {item.dc_no && (
                            <Copy
                              size={14}
                              className="text-muted cursor-pointer"
                              style={{
                                cursor: 'pointer',
                                opacity: 0.5,
                                transition: 'opacity 0.2s'
                              }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.opacity = 1)
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.opacity = 0.5)
                              }
                              onClick={() => handleCopy(item.dc_no)}
                              title="Copy DC Number"
                            />
                          )}
                        </div>
                      </td>
                      <td className="p-2 align-middle text-muted">
                        {item.customer}
                      </td>
                      <td className="p-2 align-middle text-muted">
                        {item.source_warehouse}
                      </td>
                      <td className="p-2 align-middle">
                        {item.outbound ? (
                          <Link
                            to={`/outbound/plan/detail/${item.outbound}`}
                            className="text-decoration-none"
                          >
                            {item.outbound}
                          </Link>
                        ) : (
                          '-'
                        )}
                      </td>
                      <td className="p-2 align-middle">
                        <BadgeStatusPrLists text={item.status} />
                      </td>
                      <td className="p-2 align-middle">
                        {item.date
                          ? convertDateWithTime(item.date, 'DD-MM-YYYY')
                          : '-'}
                      </td>
                      <td className="p-2 align-middle text-end">
                        <TableAction>
                          <Button
                            variant="light"
                            className="btn-sm border rounded text-secondary"
                            style={{
                              width: '32px',
                              height: '32px',
                              padding: 0
                            }}
                            onClick={() =>
                              navigate(
                                `/outbound/request-return/detail/${encodeURIComponent(
                                  item.code
                                )}`,
                                { state: filter }
                              )
                            }
                          >
                            <Search size={14} />
                          </Button>
                        </TableAction>
                      </td>
                    </tr>
                  ))}
              </tbody>
              <tfoot>
                <tr>
                  <td className="p-3 border-top-0" colSpan={8}>
                    <TablePagination
                      meta={meta}
                      handlePageChange={handlePageChange}
                      handleOnChangeMeta={handleOnChangeMeta}
                    />
                  </td>
                </tr>
              </tfoot>
            </Table>
          </Col>
        </Row>
      </Container>
      <Toaster />
    </>
  )
}
export default RequestReturn
